import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import KeyCode from 'rc-util/lib/KeyCode';
import { polyfill } from 'react-lifecycles-compat';
import DateTable from './date/DateTable';
import CalendarHeader from './calendar/CalendarHeader';
import CalendarFooter from './calendar/CalendarFooter';
import { calendarMixinWrapper, calendarMixinPropTypes, calendarMixinDefaultProps, getNowByCurrentStateValue } from './mixin/CalendarMixin';
import { commonMixinWrapper, propType, defaultProp } from './mixin/CommonMixin';
import DateInput from './date/DateInput';
import { getTimeConfig, getTodayTime, syncTime } from './util';
import { goStartMonth, goEndMonth, goTime } from './util/toTime';
import { updateValueLocale } from '../lang-utils';
import moment from 'moment';

function noop() {}

var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar(_props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value, mode) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      if (!('mode' in props)) {
        _this.setState({
          mode: mode
        });
      }

      props.onPanelChange(value || state.value, mode);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.target.nodeName.toLowerCase() === 'input') {
        return undefined;
      } else {
        _this.props.onKeyDown && _this.props.onKeyDown(event);
      }

      var keyCode = event.keyCode; // mac

      var ctrlKey = event.ctrlKey || event.metaKey;
      var disabledDate = _this.props.disabledDate;
      var value = _this.state.value;

      switch (keyCode) {
        case KeyCode.DOWN:
          _this.goTime(1, 'weeks');

          event.preventDefault();
          return 1;

        case KeyCode.UP:
          _this.goTime(-1, 'weeks');

          event.preventDefault();
          return 1;

        case KeyCode.LEFT:
          if (ctrlKey) {
            _this.goTime(-1, 'years');
          } else {
            _this.goTime(-1, 'days');
          }

          event.preventDefault();
          return 1;

        case KeyCode.RIGHT:
          if (ctrlKey) {
            _this.goTime(1, 'years');
          } else {
            _this.goTime(1, 'days');
          }

          event.preventDefault();
          return 1;

        case KeyCode.HOME:
          _this.setValue(goStartMonth(_this.state.value));

          event.preventDefault();
          return 1;

        case KeyCode.END:
          _this.setValue(goEndMonth(_this.state.value));

          event.preventDefault();
          return 1;

        case KeyCode.PAGE_DOWN:
          _this.goTime(1, 'month');

          event.preventDefault();
          return 1;

        case KeyCode.PAGE_UP:
          _this.goTime(-1, 'month');

          event.preventDefault();
          return 1;

        case KeyCode.ENTER:
          if (!disabledDate || !disabledDate(value)) {
            _this.onSelect(value, {
              source: 'keyboard'
            });
          }

          event.preventDefault();
          return 1;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      _this.onSelect(null);

      _this.props.onClear();
    });

    _defineProperty(_assertThisInitialized(_this), "onOk", function () {
      var selectedValue = _this.state.selectedValue;

      if (_this.isAllowedDate(selectedValue)) {
        _this.props.onOk(selectedValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateInputChange", function (value) {
      _this.onSelect(value, {
        source: 'dateInput'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateInputSelect", function (value) {
      _this.onSelect(value, {
        source: 'dateInputSelect'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateTableSelect", function (value) {
      var timePicker = _this.props.timePicker;
      var selectedValue = _this.state.selectedValue;

      _this.setState({
        panelValue: ''
      });

      if (!selectedValue && timePicker) {
        var timePickerDefaultValue = timePicker.props.defaultValue;

        if (timePickerDefaultValue) {
          syncTime(timePickerDefaultValue, value);
        }
      }

      _this.onSelect(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onToday", function () {
      var value = _this.state.value;
      var now = getTodayTime(value);

      _this.onSelect(now, {
        source: 'todayButton'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getRootDOMNode", function () {
      return ReactDOM.findDOMNode(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "openTimePicker", function () {
      _this.onPanelChange(null, 'time');
    });

    _defineProperty(_assertThisInitialized(_this), "closeTimePicker", function () {
      _this.onPanelChange(null, 'date');
    });

    _defineProperty(_assertThisInitialized(_this), "goTime", function (direction, unit) {
      _this.setValue(goTime(_this.state.value, direction, unit));
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (e) {
      e.stopPropagation();
    });

    _this.state = {
      mode: _this.props.mode || 'date',
      value: _props.value || _props.defaultValue || moment(),
      selectedValue: _props.selectedValue || _props.defaultSelectedValue,
      panelValue: _props.panelValue || ''
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.showDateInput) {
        this.saveFocusElement(DateInput.getInstance());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      var locale = props.locale,
          prefixCls = props.prefixCls,
          disabledDate = props.disabledDate,
          validatorFunc = props.validatorFunc,
          format = props.format,
          dateInputPlaceholder = props.dateInputPlaceholder,
          timePicker = props.timePicker,
          disabledTime = props.disabledTime,
          clearIcon = props.clearIcon,
          renderExtraFooter = props.renderExtraFooter,
          showMonthInput = props.showMonthInput,
          renderError = props.renderError,
          onInputBlur = props.onInputBlur,
          inputReadOnly = props.inputReadOnly;
      var value = state.value,
          selectedValue = state.selectedValue,
          mode = state.mode;
      var showTimePicker = mode === 'time';
      var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? getTimeConfig(selectedValue, disabledTime) : null;
      var timePickerEle = null;

      if (timePicker && showTimePicker) {
        var timePickerProps = _objectSpread(_objectSpread(_objectSpread({
          showHour: true,
          showSecond: true,
          showMinute: true
        }, timePicker.props), disabledTimeConfig), {}, {
          onChange: this.onDateInputChange,
          value: selectedValue,
          disabledTime: disabledTime
        });

        if (timePicker.props.defaultValue !== undefined) {
          timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
        }

        timePickerEle = /*#__PURE__*/React.cloneElement(timePicker, timePickerProps);
      }

      updateValueLocale(props.locale, value); //同步moment实例的locale值

      updateValueLocale(props.locale, this.state.panelValue); //同步moment实例的locale值

      var dateInputElement = props.showDateInput ? /*#__PURE__*/React.createElement(DateInput, {
        format: this.getFormat(),
        key: "date-input",
        value: value,
        locale: locale,
        placeholder: dateInputPlaceholder,
        showClear: true,
        disabledTime: disabledTime,
        disabledDate: disabledDate,
        onClear: this.onClear,
        inputReadOnly: inputReadOnly,
        prefixCls: prefixCls,
        selectedValue: selectedValue,
        onChange: this.onDateInputChange,
        onSelect: function onSelect(value) {
          if (moment(value, format, true) && validatorFunc(value)) {
            _this2.onDateInputSelect(value);
          }
        },
        clearIcon: clearIcon,
        renderError: renderError,
        onBlur: onInputBlur,
        validatorFunc: validatorFunc
      }) : null;
      var children = [];

      if (props.renderSidebar) {
        children.push(props.renderSidebar());
      }

      children.push( /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-panel"),
        key: "panel"
      }, dateInputElement, /*#__PURE__*/React.createElement("div", {
        tabIndex: this.props.focusablePanel ? 0 : undefined,
        className: "".concat(prefixCls, "-date-panel"),
        onMouseOver: this.onMouseOver
      }, /*#__PURE__*/React.createElement(CalendarHeader, {
        locale: locale,
        mode: mode,
        value: this.state.panelValue || value,
        onValueChange: this.setValue,
        onPanelChange: this.onPanelChange,
        renderFooter: renderExtraFooter,
        showTimePicker: showTimePicker,
        prefixCls: prefixCls,
        showMonthInput: showMonthInput
      }), timePicker && showTimePicker ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-time-picker")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-time-picker-panel")
      }, timePickerEle)) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, /*#__PURE__*/React.createElement(DateTable, {
        locale: locale,
        value: this.state.panelValue || value,
        selectedValue: selectedValue,
        prefixCls: prefixCls,
        dateRender: props.dateRender,
        onSelect: this.onDateTableSelect,
        disabledDate: disabledDate,
        showWeekNumber: props.showWeekNumber
      })), /*#__PURE__*/React.createElement(CalendarFooter, {
        showOk: props.showOk,
        mode: mode,
        renderFooter: props.renderExtraFooter,
        locale: locale,
        prefixCls: prefixCls,
        showToday: props.showToday,
        disabledTime: disabledTime,
        showTimePicker: showTimePicker,
        showDateInput: props.showDateInput,
        timePicker: timePicker,
        selectedValue: selectedValue,
        value: value,
        disabledDate: disabledDate,
        okDisabled: props.showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)),
        onOk: this.onOk,
        onSelect: this.onSelect,
        onToday: this.onToday,
        onOpenTimePicker: this.openTimePicker,
        onCloseTimePicker: this.closeTimePicker
      }))));
      return this.renderRoot({
        children: children,
        className: props.showWeekNumber ? "".concat(prefixCls, "-week-number") : ''
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var value = nextProps.value,
          selectedValue = nextProps.selectedValue,
          panelValue = nextProps.panelValue;
      var newState = {};

      if ('mode' in nextProps && state.mode !== nextProps.mode) {
        newState = {
          mode: nextProps.mode
        };
      }

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(state.value);
      }

      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      if ('panelValue' in nextProps) {
        newState.panelValue = panelValue;
      }

      return newState;
    }
  }]);

  return Calendar;
}(React.Component);

_defineProperty(Calendar, "propTypes", _objectSpread(_objectSpread(_objectSpread({}, calendarMixinPropTypes), propType), {}, {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.object,
  value: PropTypes.object,
  selectedValue: PropTypes.object,
  defaultSelectedValue: PropTypes.object,
  mode: PropTypes.oneOf(['time', 'date', 'month', 'year', 'decade']),
  locale: PropTypes.object,
  showDateInput: PropTypes.bool,
  showWeekNumber: PropTypes.bool,
  showToday: PropTypes.bool,
  showOk: PropTypes.bool,
  onSelect: PropTypes.func,
  onOk: PropTypes.func,
  onKeyDown: PropTypes.func,
  timePicker: PropTypes.element,
  dateInputPlaceholder: PropTypes.any,
  onClear: PropTypes.func,
  onChange: PropTypes.func,
  onPanelChange: PropTypes.func,
  disabledDate: PropTypes.func,
  disabledTime: PropTypes.any,
  dateRender: PropTypes.func,
  renderExtraFooter: PropTypes.func,
  renderSidebar: PropTypes.func,
  clearIcon: PropTypes.node,
  focusablePanel: PropTypes.bool
}));

_defineProperty(Calendar, "defaultProps", _objectSpread(_objectSpread(_objectSpread({}, calendarMixinDefaultProps), defaultProp), {}, {
  showToday: true,
  showDateInput: true,
  timePicker: null,
  onOk: noop,
  onPanelChange: noop,
  focusablePanel: true
}));

polyfill(Calendar);
export default calendarMixinWrapper(commonMixinWrapper(Calendar));


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/Calendar.js